const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'base',
        'scheduler',
        'scheduler',
    ],

    config: {
        filterDelay: 50,
        tripsControllerComponentClass: 'templates_office_trips_controller',
        summaryComponentClass: 'templates_office_scheduler_tripSummary',
        showNav: {
            subTitle: true,
        },
    },

    model: {
        loadedStatusIDs: {}, // stores all statusIDs loaded to determine if a refresh is necessary when heartbeat wants to refresh specific statusIDs.
        filterTimeout: null,
        summaryComponent: null, // problemSummary component to update on hover if necessary
    },

    methods: {
        getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
            if(actionKey === 'refreshResources'){
                resourceFilters = resourceFilters || {}

                if(utils.collectionSize(this.model.resourceFilters) > 0){
                    utils.refReplace(resourceFilters, this.model.resourceFilters)
                }

                this.model.resourceFilters = resourceFilters
                this.sanitizeResourceFilters(storage, resourceFilters, actionKey, true)
            } else {
                this.sanitizeResourceFilters(storage, resourceFilters, actionKey, false)
            }

            return resourceFilters
        },

        sanitizeResourceFilters(storage, resourceFilters, actionKey){
            resourceFilters = resourceFilters || {}

            if(actionKey === 'refreshResources'){
                resourceFilters.filters                 = resourceFilters.filters || {}
                resourceFilters.filters.visibleRange    = {...(this.model.visibleRange || {})}
            }
        },

        loadResourcesGranted(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
            if(actionKey === 'refreshResources'){
                return utils.collectionSize(((resourceFilters || {}).filters || {}).visibleRange || {}) >= 2
            }

            return true
        },

        updateFilters(filters){
            this.model.resourceFilters = this.model.resourceFilters || {}

            if(!utils.isEqual(this.model.resourceFilters.filters || {}, filters || {})){
                this.model.resourceFilters.filters = {...filters}

                // prevent multiple resource loading operations on init via delay
                this.delayedLastOf('refreshByFilterUpdate', () => this.refresh(), this.config.filterDelay)
            }
        },

        sanitizeResources(storage){
            this.model.taskData = []
            this.model.loadedStatusIDs = {}

            let showIDs = false
            const user = (storage || {}).user
            if(user) {
                showIDs = showIDs || user.hasRoleOption('showIDs', this.scope)
            }

            let entitySymbol, statusSymbol, alt
            utils.forEach(this.resourceData.data || [], (element, key) => {
                const attributes = element.attributes || {}
                const type = attributes.type
                const taskClasses = [type]
                alt = attributes.title

                entitySymbol = ''
                statusSymbol = ''

                if(type === 'trip'){
                    if(attributes.status){
                        taskClasses.push(`status_${attributes.status}`)
                    }

                    const notInfo = attributes.notInfo || {}
                    const flags = {
                        // info, ok, error
                        offer:          attributes.offerSent           ? 'ok' : (notInfo.offer ? 'error' : 'info'),
                        confirmation:   attributes.confirmationSent    ? 'ok' : (notInfo.confirmation ? 'error' : 'info'),
                        driveOrder:     attributes.driveOrderIssued    ? 'ok' : (notInfo.driveOrder ? 'error' : 'info'),
                        invoice:        attributes.invoiceSent         ? 'ok' : (notInfo.invoice ? 'error' : 'info'),
                    }
                    const renderedFlags = []
                    for(const [flag, severity] of Object.entries(flags)){
                        renderedFlags.push(`<div class="severity_${severity}" title="${storage.__(`trips.status.flagTitle.${flag}.${severity}`)}">&nbsp;</div>`)
                    }
                    statusSymbol = `<div class="statusFlags">${renderedFlags.join('')}</div>`

                    const conflictTripIDs = Object.keys(attributes.conflictTripIDs || {})
                    if(conflictTripIDs.length){
                        statusSymbol = `<i class="statusSymbol fi fi-severity-warning severity_warning" title="${storage.__(`scheduler.entities.trip.tripDriverVesselConflicts.${conflictTripIDs.length > 1 ? 'multi' : 'single'}`, { count: attributes.nrOfTripDriverVesselConflicts || 0, conflictTripIDs: conflictTripIDs.join(', '), nrOfConflictTrips: conflictTripIDs.length })}">&nbsp;</i>`
                    }

                    if(attributes.status){
                        alt = `${storage.__(`trips.status.${attributes.status}`)}: ${alt}`
                    }
                    if(showIDs){
                        alt = `#${attributes.tripID}: ${alt}`
                    }

                } else {
                    entitySymbol = `<i class="entitySymbol fi fi-${type}"></i>`
                }

                this.model.taskData.push({
                    title: `${entitySymbol}<div class="term">${attributes.title || ''}</div>${statusSymbol}`,
                    alt,
                    date: attributes.startTS,
                    class: taskClasses.join(' '),
                    dataType: type,
                    dataID: key,
                    showTime: false,
                    attributes,
                })
            })
        },

        onSanitizeTasksDone(){
            // add additional, day dependent markers for to add some styles like sundays, holidays, ...
            const meta = this.resourceData.meta || {}
            const holidays = meta.holidays || {}
            const schoolVacation = meta.schoolVacation || {}

            let holiday, vacation
            for(const day of this.model.calendarDays){
                if((holiday = holidays[day.date || 'na'])){
                    day.additionalCSS += ' holiday'
                }
                if((vacation = schoolVacation[day.date || 'na'])){
                    day.additionalCSS += ' schoolVacation'
                }
            }
        },

        async onTaskClicked(taskType, taskID){
            const {dataType} = (this.model.taskData[taskID] || {})
            if(dataType === 'trip'){
                const {tripID} = (this.model.taskData[taskID].attributes || {})
                if(tripID){
                    const controller = getComponent($(`.${this.config.tripsControllerComponentClass}`))
                    if(controller){
                        return controller.showEdit('trips', tripID, {
                            attributes: { tripID },
                            primaryKey: 'tripID'
                        })
                    }
                }
            }
        },

        onTaskHoverIn(taskType, taskID){
            const {dataType} = (this.model.taskData[taskID] || {})
            if(!this.model.summaryComponent && this.config.summaryComponentClass){
                this.locate(`< templates_core_controller_controller > ${this.config.summaryComponentClass}`, c => {
                    this.model.summaryComponent = c
                })
            }

            if(!this.model.summaryComponent) return;

            if(dataType === 'trip'){
                this.model.summaryComponent.update(this.model.taskData[taskID].attributes || {})
            }
        },

        onTaskHoverOut(taskType, taskID){
            if(!this.model.summaryComponent) return;
            this.model.summaryComponent.update()
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers    = this.config.heartbeatRefreshOn || {}
            const key           = message.heartbeatKey

            if(refreshers[key]){
                this.delayedLastOf('refreshByHeartbeat', () => this.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            }
        },
    },
}